import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Close } from "@material-ui/icons";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import React from "react";
import { Controller, useWatch } from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { format, parse } from "date-fns";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { formatDatetime } from "../../../../util";

const filmScreeningsDefaultValue = {
  startDatetime: new Date(),
  endDatetime: new Date(),
  type: "cinema",
  venue: null,
  buyTicketUrl: "",
  haveGuest: 0,
  status: "ACTIVE",
  stock: 1,
  code: "",
  availability: "buy_ticket",
  programmeUpdates: [],
};

const useStyles = makeStyles((theme) => ({
  filmScreeningsBlk: {
    background: "#FFFFFF",
    marginBottom: "20px",
  },
  filmScreeningsBlkHeader: {
    background: "#EDEEF0",
    borderLeft: "3px solid #9D3030",
    fontWeight: "bold",
    fontSize: "14px",
    lineHeight: "16px",
    padding: "12px 13px",
  },
  filmScreeningsBlkBody: {
    border: "1px solid #CCCCCC",
    borderTop: "0px",
    padding: "20px 13px",
  },
  deleteBtn: {
    margin: "0",
    padding: "0",
    minWidth: "initial",
  },
  input: {
    width: "100%",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
    },
  },
  select: {
    marginLeft: "4px",
  },
}));

const FilmScreeningsBlock = ({
  control,
  index,
  classes,
  disabled,
  remove,
  data,
  setValue,
  venueList,
}) => {
  const filmScreenings = useWatch({
    control,
    name: `filmScreenings[${index}]`,
  });

  return (
    <>
      <Grid
        container
        className={classes.filmScreeningsBlkHeader}
        xs={12}
        alignItems="center"
        justify="space-between"
      >
        <span>Screening {index + 1}</span>
        {disabled || (
          <Button className={classes.deleteBtn} onClick={() => remove(index)}>
            <Close
              style={{
                fontSize: "14px",
                lineHeight: "16px",
              }}
            />
          </Button>
        )}
      </Grid>
      <Box className={classes.filmScreeningsBlkBody}>
        <Grid container spacing={3} direction="column">
          <Grid container item xs={12} spacing={3}>
            <Grid container item xs={6} spacing={3}>
              <Grid item xs={6}>
                <Controller
                  defaultValue={data?.startDatetime}
                  name={`filmScreenings[${index}].startDatetime`}
                  control={control}
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => {
                    return (
                      <KeyboardDateTimePicker
                        id={`startTime-picker${index}`}
                        fullWidth
                        minutesStep={5}
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        ampm={false}
                        label="Start Date Time"
                        value={value}
                        onChange={(date, value) => {
                          setValue(
                            `filmScreenings[${index}].startDatetime`,
                            value
                          );
                        }}
                        onError={console.log}
                        disablePast
                        format="yyyy-MM-dd HH:mm"
                        error={!!error}
                        helperText={error ? error.message : ""}
                        {...rest}
                      />
                    );
                  }}
                />
              </Grid>
              <Grid
                item
                xs={6}
                // style={{
                //   display:
                //     filmScreenings && filmScreenings.type === "online"
                //       ? "block"
                //       : "none",
                // }}
              >
                <Controller
                  defaultValue={data?.endDatetime}
                  name={`filmScreenings[${index}].endDatetime`}
                  control={control}
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => {
                    return (
                      <KeyboardDateTimePicker
                        id={`endTime-picker${index}`}
                        fullWidth
                        minutesStep={5}
                        disabled={disabled}
                        margin="dense"
                        variant="inline"
                        ampm={false}
                        label="End Date Time"
                        value={value}
                        onChange={(date, value) => {
                          setValue(
                            `filmScreenings[${index}].endDatetime`,
                            value
                          );
                        }}
                        onError={console.log}
                        disablePast
                        format="yyyy-MM-dd HH:mm"
                        error={!!error}
                        helperText={error ? error.message : ""}
                        {...rest}
                      />
                    );
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item xs={3} alignItems="center">
              <Controller
                defaultValue={data?.type}
                name={`filmScreenings[${index}].type`}
                control={control}
                render={({
                  field: { value, onChange, ...rest },
                  fieldState: { error },
                }) => (
                  <ToggleButtonGroup
                    {...rest}
                    value={filmScreenings?.type}
                    onChange={(event, newFormats) => {
                      if (newFormats) {
                        // onChange(newFormats);
                        setValue(`filmScreenings[${index}].type`, newFormats);
                      }
                    }}
                    exclusive
                    aria-label="period status"
                    className={classes.input}
                  >
                    <ToggleButton
                      value="online"
                      aria-label="online"
                      disabled={disabled}
                    >
                      Online filmScreenings
                    </ToggleButton>
                    <ToggleButton
                      value="cinema"
                      aria-label="offline"
                      disabled={disabled}
                    >
                      Offline filmScreenings
                    </ToggleButton>
                  </ToggleButtonGroup>
                )}
              />
            </Grid>
          </Grid>
          <Grid container item xs={12}>
            <Controller
              defaultValue={data?.venue}
              name={`filmScreenings[${index}].venue`}
              control={control}
              render={({
                field: { onChange, value, ...rest },
                fieldState: { error },
              }) => {
                return (
                  <Autocomplete
                    fullWidth
                    label="Venue"
                    options={venueList}
                    disabled={disabled}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Venue"
                          margin="dense"
                          placeholder="Venues"
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      );
                    }}
                    value={venueList.find((item) => item.id === filmScreenings?.venue) ?? null}
                    onChange={(e, values) => {
                      // onChange(values);
                      setValue(`filmScreenings[${index}].venue`, values?.id);
                    }}
                    {...rest}
                  />
                );
              }}
            />
          </Grid>
          <Grid container item xs={12}>
            <Controller
              defaultValue={data?.buyTicketUrl}
              name={`filmScreenings[${index}].buyTicketUrl`}
              control={control}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => (
                <TextField
                  label="Buy Ticket URL"
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : ""}
                  InputLabelProps={{ shrink: true }}
                  {...rest}
                  onChange={(event) => {
                    setValue(
                      `filmScreenings[${index}].buyTicketUrl`,
                      event.target.value
                    );
                  }}
                  value={value}
                />
              )}
            />
          </Grid>

          <Grid container item xs={12}>
            <Grid container item xs={6}>
              <Controller
                defaultValue={data?.code}
                name={`filmScreenings[${index}].code`}
                control={control}
                render={({
                  field: { value, onChange, ...rest },
                  fieldState: { error },
                }) => (
                  <TextField
                    label="Code"
                    variant="outlined"
                    margin="dense"
                    className={classes.textInput}
                    fullWidth
                    error={!!error}
                    helperText={error ? error.message : ""}
                    InputLabelProps={{ shrink: true }}
                    {...rest}
                    onChange={(event) => {
                      // onChange(event.target.value);
                      setValue(
                        `filmScreenings[${index}].code`,
                        event.target.value
                      );
                    }}
                    value={filmScreenings?.code}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid container item xs={6} alignItems="center">
            <FormControl fullWidth variant="outlined">
              <InputLabel id="ticketStatus-selection">Ticket Status</InputLabel>
              <Controller
                defaultValue={data?.availability}
                name={`filmScreenings[${index}].availability`}
                control={control}
                render={({
                  field: { value, ...rest },
                  fieldState: { error },
                }) => (
                  <Select
                    labelId="ticketStatus-selection-label"
                    id="ticketStatus-selection"
                    label="Ticket Status"
                    value={value}
                    className={classes.select}
                    {...rest}
                  >
                    <MenuItem value={"buy_ticket"}>
                      <em>Buy Ticket</em>
                    </MenuItem>
                    <MenuItem value={"sold_out"}>
                      <em>Sold Out</em>
                    </MenuItem>
                    <MenuItem value={"sell_at_venue"}>
                      <em>Sell At Venue</em>
                    </MenuItem>
                    <MenuItem value={"free"}>
                      <em>Free</em>
                    </MenuItem>
                    <MenuItem value={"cancel"}>
                      <em>Cancel</em>
                    </MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="guest-selection">Have Guest</InputLabel>
              <Controller
                defaultValue={data?.haveGuest}
                name={`filmScreenings[${index}].haveGuest`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <Select
                    labelId="guest-selection-label"
                    id="guest-selection"
                    label="Have Guest"
                    value={2}
                    className={classes.select}
                    {...field}
                  >
                    <MenuItem value={3}>
                      <em>Filmmaker/film critic will attend the screening</em>
                    </MenuItem>
                    <MenuItem value={1}>
                      <em>
                        Meet-the-filmmaker through video or live streaming
                      </em>
                    </MenuItem>
                    <MenuItem value={0}>
                      <em>No</em>
                    </MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4} style={{ marginLeft: "8px" }}>
            <Controller
              defaultValue={data?.stock}
              name={`filmScreenings[${index}].stock`}
              control={control}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => {
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{ marginLeft: "4px" }}
                        type="checkbox"
                        color="primary"
                        checked={value === 0}
                        {...rest}
                        onChange={(event) => {
                          setValue(
                            `filmScreenings[${index}].stock`,
                            event.target.checked ? 0 : 1
                          );
                        }}
                      />
                    }
                    label="Full"
                  />
                );
              }}
            />
          </Grid>

          <Box fontWeight={900} fontSize={13} mt={1} ml={3} width="100%">
            <Typography variant="p">Status</Typography>
          </Box>

          <Grid item xs={4} style={{ marginLeft: "8px" }}>
            <Controller
              defaultValue={data?.status}
              control={control}
              name={`filmScreenings[${index}].status`}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => (
                <ToggleButtonGroup
                  {...rest}
                  value={value}
                  onChange={(event, newFormats) => {
                    if (newFormats !== null) {
                      onChange(newFormats);
                    }
                  }}
                  exclusive
                  aria-label="Full"
                  className={classes.input}
                >
                  <ToggleButton
                    value={"ACTIVE"}
                    aria-label="Active"
                    style={{ width: "50%" }}
                  >
                    Active
                  </ToggleButton>
                  <ToggleButton
                    value={"INACTIVE"}
                    aria-label="Inactive"
                    style={{ width: "50%" }}
                  >
                    Inactive
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default function FilmScreeningsSections(props) {
  const { control, setValue, venueList, disabled, fields, remove, append } =
    props;

  const classes = useStyles();

  return (
    <>
      {fields.map((data, index) => (
        <div className={classes.filmScreeningsBlk} key={data.id}>
          <FilmScreeningsBlock
            {...{
              control,
              index,
              classes,
              disabled,
              remove,
              data,
              setValue,
              venueList,
            }}
          />
        </div>
      ))}
      {disabled || (
        <Button
          type="button"
          onClick={() => {
            append(filmScreeningsDefaultValue);
          }}
          style={{
            color: "#306F9D",
            margin: "5px 0",
          }}
        >
          <AddCircleIcon />
          Add Screening
        </Button>
      )}
    </>
  );
}
